import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    MdCheckCircleOutline,
    MdChevronLeft,
    MdChevronRight,
    MdLockOutline,
    MdStore,
    MdContentCopy
} from 'react-icons/md';
import { AiOutlineLoading } from "react-icons/ai";
import qs from 'qs';
import PaymentMethod from "../../components/paymentMethods";
import OrderService from "../../rest/orderService";
import ProductGridSale from "../../components/productGridSale";
import MenuService from "../../rest/menuService";
import TopNavBar from "../../components/reusables/topNavBar";
import NotificationsService from "../../rest/notificationService";
import ProductService from "../../rest/productService";
import FinancialService from "../../rest/financialService";
import ComboService from "../../rest/comboService";
import ClientService from "../../rest/clientService";
import CustomerGridSale from "../../components/customerGridSale";
import ModalPortal from "../../components/lib/modalPortal";
import OrderSummary from "../../components/reusables/orderSummary";
import Stepper from "../../components/lib/stepperHeader";
import { ajustedDate, getToday } from "../../utils/DateUtils";
import { formatCurrency } from "../../utils/CurrencyUtils";

const NewOrder = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const isSubmittingRef = useRef(false);
    const receiptWinRef = useRef(null);

    const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
    const [customer, setCustomer] = useState('');
    const [totalSpentToday, setTotalSpentToday] = useState(0.0);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [list, setList] = useState([]);
    const [totalAmount, setTotalAmount] = useState(0);
    const [itemCount, setItemCount] = useState(0);
    const [currentStep, setCurrentStep] = useState(1);
    const [isOpened, setIsOpened] = useState(true);
    const [checkingStatus, setCheckingStatus] = useState(true);
    const [clientInfo, setClientInfo] = useState();
    const [preferences, setPreferences] = useState();

    const [showModalConfirmPayment, setshowModalConfirmPayment] = useState(false);
    const [showInsuficientCreditsMessage, setshowInsuficientCreditsMessage] = useState(false);
    const [showModalDailyLimit, setShowModalDailyLimit] = useState(false);
    const [pixData, setPixData] = useState({ qrCodeImage: null, copyPasteCode: null });

    const operator = sessionStorage.getItem('name');
    const [order, setOrder] = useState({
        order_id: '',
        cashier_id: '',
        client_id: '',
        items_list: '',
        total: '',
        received_value: '',
        status: '',
        sale_point: '',
        clientCode: '',
        transactions: [],
        reservation_id: null
    });

    const steps = isMobile ? ['Cliente', 'Pedido', 'Pagamento', 'Resumo'] : ['Cliente', 'Pedido', 'Pagamento'];

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 1024);
        window.addEventListener('resize', handleResize);
        const info = JSON.parse(sessionStorage.getItem('clientInfo'));
        setClientInfo(info);

        const init = async () => {
            try {
                const data = await FinancialService.checkIfOpen(getToday());
                setIsOpened(data);
                const prefs = await ClientService.getClientAdminPreferences();
                setPreferences(prefs);
            } catch (e) { console.error(e); } finally { setCheckingStatus(false); }
        };
        init();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const amount = selectedProducts.reduce((acc, curr) => acc + (curr.price * curr.quantity), 0);
        setTotalAmount(amount.toFixed(2));
        setItemCount(selectedProducts.reduce((acc, curr) => acc + curr.quantity, 0));
    }, [selectedProducts]);

    useEffect(() => {
        if (customer) {
            setOrder(prev => ({
                ...prev,
                order_id: prev.order_id || Math.floor(Math.random() * 999999999),
                cashier_id: operator,
                client_id: `${customer.login} / ${customer.name}`,
                purchase_date: ajustedDate(),
                items_list: selectedProducts.map(p => `${p.id} x${p.name} x${p.quantity} x${p.type} x${p.price}`).join(', '),
                total: totalAmount,
                sale_point: 'WEBAPP',
                clientCode: sessionStorage.getItem('clientCode'),
                last_update: ajustedDate(),
            }));
        }
    }, [customer, totalAmount, selectedProducts, operator]);

    const handleStep1Value = (value) => {
        if (!value) { setCustomer(''); setTotalSpentToday(0); return; }
        setCustomer(value);
        OrderService.getClientTodayTotalSpent(value.login).then(setTotalSpentToday).catch(console.error);
    };

    const handleChooseItem = (item, action) => {
        const updated = [...selectedProducts];
        const idx = updated.findIndex(i => i.id === item.id);
        if (action === "plus") {
            if (idx !== -1) updated[idx].quantity += 1;
            else { const { imageData, ...cleanItem } = item; updated.push({ ...cleanItem, quantity: 1 }); }
        } else if (action === "minus" && idx !== -1) {
            updated[idx].quantity -= 1;
            if (updated[idx].quantity <= 0) updated.splice(idx, 1);
        } else if (action === "remove" && idx !== -1) { updated.splice(idx, 1); }
        setSelectedProducts(updated);
    };

    const totalReceived = (order.transactions || []).reduce((acc, tx) => acc + (parseFloat(tx.received_value) || 0), 0);
    const change = totalReceived - totalAmount;

    const isCardBrandMissing = () => {
        if (!order.transactions || order.transactions.length === 0) return false;
        return !order.transactions.every(transaction => {
            const method = (transaction.paymentMethod || '').toLowerCase();
            const parts = (transaction.paymentMethod || '').split('/');
            if (method.startsWith('crédito') || method.startsWith('débito')) {
                return parts[1] && parts[1].trim().length > 0;
            }
            return true;
        });
    };

    const handleSubmit = async () => {
        if (isSubmittingRef.current) return;

        if (isCardBrandMissing()) {
            alert("Erro: Selecione a bandeira do cartão antes de finalizar.");
            return;
        }

        isSubmittingRef.current = true;
        setLoading(true);

        try {
            order.transactions = mergeTransactions(order.transactions || []);
            const total = parseFloat(order.total || 0);
            const totalToday = parseFloat(totalSpentToday || 0);

            if (total + totalToday > customer.spend_limit) {
                setShowModalDailyLimit(true);
                setLoading(false);
                isSubmittingRef.current = false;
                return;
            }

            try {
                receiptWinRef.current = openReceiptPopupPlaceholder();
            } catch (err) {
                receiptWinRef.current = null;
            }

            if (order.transactions.length === 1 && order.transactions[0].paymentMethod === 'CREDITO FOODZ') {
                setLoading(true);
                order.status = 'COMPLETED';

                if (!checkBalanceForOrder()) {
                    setshowInsuficientCreditsMessage(true);
                    setLoading(false);
                    isSubmittingRef.current = false;
                    if (receiptWinRef.current) receiptWinRef.current.close();
                    return;
                }

                const resp = await OrderService.registerOrder({ order });
                if (resp && (resp.status === 201 || resp.status === 200)) {
                    const savedOrder = resp.data?.order || {};
                    if (savedOrder.order_id) order.order_id = savedOrder.order_id;

                    const updateSuccess = await updateProductData();
                    if (updateSuccess) {
                        handleClickFinalize(receiptWinRef.current);
                        notifyPurchase();
                    }
                } else {
                    setLoading(false);
                    isSubmittingRef.current = false;
                }
                return;
            }

            order.status = 'PROCESSINGPAYMENT';

            const genericResp = await OrderService.registerOrder({ order });
            if (genericResp && (genericResp.status === 201 || genericResp.status === 200)) {
                const savedOrder = genericResp.data?.order || {};
                if (savedOrder.order_id) order.order_id = savedOrder.order_id;

                const payment = genericResp.data?.payment;
                if (payment?.qrCodeEncodedImage) {
                    setPixData({
                        qrCodeImage: payment.qrCodeEncodedImage,
                        copyPasteCode: payment.qrCodePayload
                    });
                }

                setLoading(false);
                setshowModalConfirmPayment(true);
            } else {
                setLoading(false);
                isSubmittingRef.current = false;
            }

        } catch (error) {
            console.error(error);
            setLoading(false);
            isSubmittingRef.current = false;
        }
    };

    const handleConfirm = async (e) => {
        e.preventDefault();
        setLoading(true);
        receiptWinRef.current = receiptWinRef.current || openReceiptPopupPlaceholder();
        try {
            const updatedOrder = { ...order, status: 'COMPLETED', clientCode: sessionStorage.getItem('clientCode') };
            const resp = await OrderService.updateOrderStatus(updatedOrder);
            if (resp) {
                const success = await updateProductData();
                if (success) {
                    handleClickFinalize(receiptWinRef.current);
                    notifyPurchase();
                }
            }
        } catch (err) { setLoading(false); }
    };

    const handleConfirmLater = async (e) => {
        e.preventDefault();
        setLoading(true);
        receiptWinRef.current = receiptWinRef.current || openReceiptPopupPlaceholder();
        try {
            const updatedOrder = { ...order, status: 'PROCESSINGPAYMENT', clientCode: sessionStorage.getItem('clientCode') };
            const resp = await OrderService.updateOrderStatus(updatedOrder);
            if (resp) {
                const success = await updateProductData();
                if (success) {
                    handleClickFinalize(receiptWinRef.current);
                    notifyPurchase();
                }
            }
        } catch (err) { setLoading(false); }
    };

    const checkBalanceForOrder = () => {
        const credit = parseFloat(customer.credit);
        const emergency = parseFloat(customer.emergency_value);
        return (credit + emergency) >= totalAmount;
    };

    const updateProductData = async () => {
        try {
            for (const s of selectedProducts) {
                const payload = { product_id: s.id, recipe_id: s.id, combo_id: s.id, quantity: s.quantity, clientCode: sessionStorage.getItem('clientCode') };
                if (s.type === "product") await ProductService.updateProductQuantity(s.id, "REMOVE", payload);
                else if (s.type === "recipe") await MenuService.updateRecipeQuantity(s.id, "REMOVE", payload);
                else if (s.type === "combo") await ComboService.updateComboQuantity(s.id, "REMOVE", payload);
            }
            return true;
        } catch (error) { return false; }
    };

    const notifyPurchase = () => {
        if (preferences?.enable_send_notifications) {
            NotificationsService.sendEmailNotificationForOrder(clientInfo, customer, order, operator, change, selectedProducts)
                .finally(() => window.location.reload());
        } else { setTimeout(() => window.location.reload(), 1000); }
    };

    const shouldShowReceipt = () => {
        const isMobileDevice = /Android|iPhone|iPad/i.test(navigator.userAgent) || window.innerWidth < 1024;
        return preferences?.enable_open_receipt && !isMobileDevice;
    };

    const openReceiptPopupPlaceholder = () => {
        if (!shouldShowReceipt()) return null;
        const win = window.open('', '_blank', 'toolbar=no,location=no,width=340,height=600');
        if (win) win.document.write("<html><body><div style='text-align:center;font-family:Arial;'><h3>Gerando comprovante...</h3></div></body></html>");
        return win;
    };

    const handleClickFinalize = (win) => {
        if (!shouldShowReceipt()) return;
        const queryString = qs.stringify({
            customer: JSON.stringify(customer.name),
            orderId: order.order_id,
            selectedProducts: JSON.stringify(selectedProducts),
            currentCredit: JSON.stringify(customer.credit),
            grade: customer.role === 'STUDENT' ? JSON.stringify(customer.grade) : JSON.stringify("COLABORADOR"),
            transactions: order.transactions,
            itemCount, totalAmount, change, totalReceived, operator,
            clientInfo: JSON.stringify(clientInfo),
            print: true,
            auto_print: preferences.enable_auto_print,
            isPayingStudent: customer.role === "STUDENT" ? customer.isPayingStudent : true,
        });
        const popup = win || window.open('', '_blank', 'toolbar=no,location=no,width=340,height=600');
        if (popup) popup.location.href = `/comprovante?${queryString}`;
    };

    const mergeTransactions = (transactions) => {
        const map = new Map();
        transactions.forEach(tx => {
            const key = (tx.paymentMethod || "").toLowerCase().trim();
            if (map.has(key)) {
                const existing = map.get(key);
                existing.value = parseFloat(existing.value) + parseFloat(tx.value || 0);
                existing.received_value = parseFloat(existing.received_value) + parseFloat(tx.received_value || 0);
            } else map.set(key, { ...tx });
        });
        return Array.from(map.values());
    };

    const validateStep = (step) => {
        switch (step) {
            case 1: return !!customer;
            case 2: return selectedProducts.length > 0;
            case 3:
                const hasTransactions = order.transactions.length > 0;
                const isChangeValid = change >= -0.01;
                const cardBrandOk = !isCardBrandMissing();
                return hasTransactions && isChangeValid && cardBrandOk;
            default: return true;
        }
    };

    const renderStepComponent = () => {
        switch (currentStep) {
            case 1: return <CustomerGridSale onValueChange={handleStep1Value} />;
            case 2: return <ProductGridSale onValueChange={setSelectedProducts} onChooseItem={handleChooseItem} selectedItems={selectedProducts} list={list} setList={setList} />;
            case 3: return <PaymentMethod totalAmount={totalAmount} onTransactionChange={txs => setOrder(p => ({ ...p, transactions: txs }))} clientId={order.client_id} acceptedPayments={preferences?.accepted_payments} />;
            case 4: return <OrderSummary customer={customer} order={order} selectedProducts={selectedProducts} itemCount={itemCount} totalAmount={totalAmount} onUpdateQuantity={handleChooseItem} change={change} totalReceived={totalReceived} />;
            default: return null;
        }
    };

    return (
        <div className="h-screen flex flex-col bg-slate-50 font-poppins overflow-hidden">
            <TopNavBar title="Novo Pedido" subtitle="" />
            <div className="flex flex-1 overflow-hidden">
                {(!checkingStatus && !isOpened) ? (
                    <div className="w-full flex flex-col items-center justify-center bg-slate-100 p-6">
                        <div className="bg-white p-10 rounded-2xl shadow-xl flex flex-col items-center text-center max-w-md border border-slate-200">
                            <MdStore size={60} className="text-red-500 mb-6" />
                            <h2 className="text-2xl font-bold text-slate-800 mb-2">Caixa Fechado</h2>
                            <button onClick={() => navigate("/financeiro")} className="bg-custom_blue text-white font-bold py-3 px-8 rounded-xl shadow-lg flex items-center gap-2">
                                <MdLockOutline /> Abrir Caixa
                            </button>
                        </div>
                    </div>
                ) : (
                    <>
                        <div className="flex-1 flex flex-col min-w-0 border-r border-slate-200">
                            <div className="w-full flex items-start justify-between px-4 mt-4 gap-4">
                                <button onClick={() => setCurrentStep(currentStep - 1)} disabled={currentStep <= 1 || loading} className="p-2 bg-gray-200 rounded-lg disabled:opacity-30 transition-all"><MdChevronLeft size={24} /></button>
                                <div className="flex-1"><Stepper steps={steps.map(label => ({ label }))} currentStep={currentStep - 1} /></div>
                                {currentStep < steps.length ? (
                                    <button onClick={() => setCurrentStep(currentStep + 1)} disabled={!validateStep(currentStep) || loading} className="bg-custom_blue text-white py-2 px-6 rounded-lg disabled:opacity-50 font-semibold shadow-md transition-all"><MdChevronRight size={24} /></button>
                                ) : (
                                    <button onClick={handleSubmit} disabled={!validateStep(currentStep) || loading} className="bg-custom_green text-white py-2 px-6 rounded-lg disabled:opacity-50 font-semibold shadow-md transition-all">
                                        <MdCheckCircleOutline size={24} />
                                    </button>
                                )}
                            </div>
                            <div className='mx-2 md:mx-6 flex-1 overflow-y-auto p-4'>{renderStepComponent()}</div>
                        </div>
                        <div className="hidden lg:flex w-[400px] flex-col bg-white shadow-xl border-l border-slate-200">
                            <div className="flex-1 overflow-y-auto p-4">
                                <OrderSummary customer={customer} order={order} selectedProducts={selectedProducts} itemCount={itemCount} totalAmount={totalAmount} onUpdateQuantity={handleChooseItem} change={change} totalReceived={totalReceived} />
                            </div>
                        </div>
                    </>
                )}
            </div>

            {showModalConfirmPayment && (
                <ModalPortal>
                    <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4 backdrop-blur-sm">
                        <div className={`bg-white rounded-2xl shadow-2xl overflow-hidden flex flex-col animate-in zoom-in duration-300 ${pixData.qrCodeImage ? 'max-w-4xl w-full' : 'max-w-lg w-full'}`}>
                            <div className="bg-custom_blue p-6 text-white text-center">
                                <h2 className="text-2xl font-bold">Confirmação de Pagamento</h2>
                                <p className="opacity-90 mt-1">Verifique os valores antes de finalizar</p>
                            </div>
                            <div className={`grid ${pixData.qrCodeImage ? 'md:grid-cols-2' : 'grid-cols-1'}`}>
                                {pixData.qrCodeImage && (
                                    <div className="p-8 bg-slate-50 border-r flex flex-col items-center justify-center text-center">
                                        <h3 className="font-bold text-slate-700 mb-4 uppercase tracking-wider text-sm">Escaneie para Pagar (PIX)</h3>
                                        <div className="bg-white p-3 rounded-2xl border-2 border-dashed border-slate-200 shadow-inner mb-6">
                                            <img src={pixData.qrCodeImage.startsWith('data:') ? pixData.qrCodeImage : `data:image/png;base64,${pixData.qrCodeImage}`} alt="PIX QR" className="w-56 h-56" />
                                        </div>
                                        <div className="flex w-full gap-2 items-center bg-white border p-3 rounded-xl shadow-sm">
                                            <input readOnly value={pixData.copyPasteCode} className="text-[10px] flex-1 truncate outline-none text-slate-400 font-mono" />
                                            <button onClick={() => { navigator.clipboard.writeText(pixData.copyPasteCode); alert("Código Copiado!") }} className="text-custom_blue p-2 hover:bg-slate-100 rounded-lg transition"><MdContentCopy size={20} /></button>
                                        </div>
                                    </div>
                                )}
                                <div className="p-8 flex flex-col justify-center bg-white">
                                    <div className="space-y-4 mb-8">
                                        <div className="flex justify-between items-center text-lg"><span className="text-slate-500">Total:</span><span className="font-bold text-slate-800">{formatCurrency(totalAmount)}</span></div>
                                        <div className="flex justify-between items-center text-lg"><span className="text-slate-500">Recebido:</span><span className="font-bold text-custom_green">{formatCurrency(totalReceived)}</span></div>
                                        <hr className="border-dashed border-slate-200" />
                                        <div className="flex justify-between items-center text-xl bg-yellow-50 p-5 rounded-2xl border border-yellow-200 shadow-sm"><span className="text-yellow-800 font-bold">Troco:</span><span className="font-bold text-yellow-900 text-2xl">{formatCurrency(change)}</span></div>
                                    </div>
                                    <div className="grid gap-3">
                                        <button onClick={handleConfirm} disabled={loading} className="w-full bg-green-500 hover:bg-green-600 text-white font-bold py-4 rounded-2xl text-lg shadow-lg transition-all flex justify-center items-center gap-2 active:scale-95 disabled:opacity-50">
                                            {loading ? <AiOutlineLoading className="animate-spin text-2xl" /> : <MdCheckCircleOutline size={28} />}
                                            <span>Confirmar e Finalizar</span>
                                        </button>
                                        {preferences?.enable_confirm_payment_later && (
                                            <button onClick={handleConfirmLater} disabled={loading} className="bg-blue-50 hover:bg-blue-100 text-custom_blue font-bold py-3 rounded-xl transition-colors disabled:opacity-50 border border-blue-100">Confirmar Depois</button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ModalPortal>
            )}

            {/* MODAIS DE ERRO/ALERTA */}
            {showInsuficientCreditsMessage && (
                <ModalPortal>
                    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-6 text-center">
                        <div className="bg-white p-8 rounded-3xl max-w-sm shadow-2xl border border-slate-100 animate-in fade-in zoom-in">
                            <h2 className="text-xl font-bold mb-2 text-slate-800">Saldo Insuficiente</h2>
                            <p className="text-slate-500 mb-6 text-sm">O cliente não possui créditos suficientes.</p>
                            <button onClick={() => setshowInsuficientCreditsMessage(false)} className="w-full bg-slate-800 text-white font-bold py-3 rounded-xl shadow-md">Voltar e Ajustar</button>
                        </div>
                    </div>
                </ModalPortal>
            )}

            {showModalDailyLimit && (
                <ModalPortal>
                    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-6 text-center">
                        <div className="bg-white p-8 rounded-3xl max-w-sm shadow-2xl border border-slate-100 animate-in fade-in zoom-in">
                            <h2 className="text-xl font-bold mb-2 text-slate-800">Limite Diário Atingido</h2>
                            <p className="text-slate-500 mb-6 text-sm">Não é possível finalizar a compra pois o cliente já atingiu o limite de gastos diários estabelecido pelo seu(s) responsável(is).</p>
                            <button onClick={() => setShowModalDailyLimit(false)} className="w-full bg-slate-800 text-white font-bold py-3 rounded-xl shadow-md">OK</button>
                        </div>
                    </div>
                </ModalPortal>
            )}

            {/* LOADING OVERLAY GERAL (CORRIGIDO) */}
            {loading && (
                <div className="fixed inset-0 bg-slate-900/60 z-[9999] flex flex-col items-center justify-center backdrop-blur-sm">
                    <div className="bg-white p-8 rounded-3xl shadow-2xl flex flex-col items-center gap-4 animate-in fade-in zoom-in">
                        <AiOutlineLoading className="animate-spin text-custom_blue text-6xl" />
                        <div className="text-center">
                            <p className="font-bold text-slate-700 text-lg">Processando Venda</p>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default NewOrder;